<template>
  <v-container fluid>
    <data-table
      url="/workflow_notifications"
      :filters="filters"
      content="workflowNotificationLists"
      :limit="6">
      <template slot="title">
        <v-layout justify-center align-center>
          <v-flex md10 class="headline">
            Flujos de cobranza
          </v-flex>
          <v-flex md2>
            <v-btn class="k-orange-linear white--text" block large @click="dialog = !dialog">
              Añadir flujo
            </v-btn>
          </v-flex>
        </v-layout>
      </template>
      <template slot="navigation-bar">
        <v-flex md12>
          <v-text-field
            v-model="filters.search"
            label="Buscar..."
            color="black"
            solo>
          </v-text-field>
        </v-flex>
      </template>
    </data-table>
    <save-dialog
      :title="title"
      :dialog="dialog"
      :form="form"
      :route="route"
      :edit="edit"
      :hasMore="false"
      :more="false">
      <template slot="content">
        <v-layout row wrap>
          <v-flex md12>
            <v-text-field
              v-model="form.name"
              v-validate="'required|max:100'"
              data-vv-name="name"
              data-vv-as="nombre"
              :error-messages="errors.collect('name')"
              label="Nombre del flujo"
              color="black">
            </v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12>
            <v-text-field
              v-model="form.description"
              v-validate="'required|max:200'"
              data-vv-name="description"
              data-vv-as="descripción"
              :error-messages="errors.collect('description')"
              label="Descripción del flujo"
              color="black">
            </v-text-field>
          </v-flex>
        </v-layout>
        <v-subheader class="pl-0">
          Limites por canal
        </v-subheader>
        <v-layout
          v-for="channel in channels"
          :key="`channel-${channel.name}`"
          mb-4
          row
          wrap
          justify-space-between
          align-center>
          <v-flex xs1 text-xs-center>
            <v-icon>
              {{ channel.icon }}
            </v-icon>
            <small class="grey--text d-block mt-2">
              {{ channel.title }}
            </small>
          </v-flex>
          <v-flex md3>
            <v-select
              v-model="form[`t_${channel.name}`]"
              :items="limitList"
              :hide-details="true"
              label="Total"
              color="black"
              autocomplete>
            </v-select>
          </v-flex>
          <v-flex md3>
            <v-select
              v-model="form[`r_${channel.name}`]"
              :items="limitList"
              :hide-details="true"
              label="Contactado"
              color="black"
              autocomplete>
            </v-select>
          </v-flex>
          <v-flex md3>
            <v-select
              v-model="form[`c_${channel.name}`]"
              :items="limitList"
              :hide-details="true"
              label="Gestión efectiva"
              color="black"
              autocomplete>
            </v-select>
          </v-flex>
        </v-layout>
      </template>
    </save-dialog>
    <delete-dialog
      :text="deleteOptions.text"
      :id="deleteOptions.id"
      url="workflow_notifications"
      :dialog="deleteOptions.dialog"
      :delete-bus="deleteBus">
    </delete-dialog>
  </v-container>
</template>

<script>
import Vue from 'vue';
import dataTable from '@/components/global/DataTable';
import saveDialog from '@/components/global/SaveDialog';
import deleteDialog from '@/components/global/DeleteDialog';
import saveDialogMixin from '@/mixins/saveDialog';
import deleteDialogMixin from '@/mixins/deleteDialog';
import workflowNotificationLists from '@/components/workflow_notification/WorkflowNotificationList';

Vue.component('workflowNotificationLists', workflowNotificationLists);

export default {
  mixins: [
    saveDialogMixin,
    deleteDialogMixin,
  ],
  components: {
    dataTable,
    saveDialog,
    deleteDialog,
  },
  data() {
    return {
      route: 'workflow_notifications',
      dialog: false,
      filters: {
        search: '',
        sort: '-created_at',
      },
      showName: 'flujo',
      form: {
        name: '',
        description: '',
        t_human: 0,
        r_human: 0,
        c_human: 0,
        t_bot: 0,
        r_bot: 0,
        c_bot: 0,
        t_ivr: 0,
        r_ivr: 0,
        c_ivr: 0,
        t_sms: 0,
        r_sms: 0,
        c_sms: 0,
        t_email: 0,
        r_email: 0,
        c_email: 0,
      },
      channels: [
        {
          icon: 'fas fa-user',
          name: 'human',
          title: 'Humano',
        },
        {
          icon: 'fas fa-robot',
          name: 'bot',
          title: 'Bot',
        },
        {
          icon: 'fas fa-phone fa-rotate-90',
          name: 'ivr',
          title: 'Ivr',
        },
        {
          icon: 'fas fa-comment',
          name: 'sms',
          title: 'Sms',
        },
        {
          icon: 'fas fa-envelope',
          name: 'email',
          title: 'Email',
        },
      ],
      limitList: [
        {
          text: 'Ilimitado',
          value: 0,
        },
      ],
    };
  },
  created() {
    for (let i = 1; i <= 100; i += 1) {
      this.limitList.push({
        text: i,
        value: i,
      });
    }
  },
};
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/workflow_notification/Index.vue